import { NgModule } from '@angular/core';
import { TgSvgModule } from '@trademe/tangram';
import { MotorsIllustrationBoatComponent } from './motors-illustration-boat.component';

@NgModule({
    declarations: [MotorsIllustrationBoatComponent],
    imports: [TgSvgModule],
    exports: [MotorsIllustrationBoatComponent]
})
export class MotorsIllustrationBoatModule {}
